
import { Component, Prop, Vue } from "vue-property-decorator";

import TableManualForms from './Tables/TableManualForms.vue'
import TableForm1 from './Tables/TableForm1.vue'
import TableForm2 from './Tables/TableForm2.vue'
import TableForm3 from './Tables/TableForm3.vue'
import TableForm4 from './Tables/TableForm4.vue'
import TableForm5 from './Tables/TableForm5.vue'
import TableForm6 from './Tables/TableForm6.vue'
import TableForm7 from './Tables/TableForm7.vue'
import TableForm8 from './Tables/TableForm8.vue'
import TableForm9 from './Tables/TableForm9.vue'
import TableForm10 from './Tables/TableForm10.vue'
import TableForm11 from './Tables/TableForm11.vue'
import TableForm12 from './Tables/TableForm12.vue'
import TableForm13 from './Tables/TableForm13.vue'
import TableForm14 from './Tables/TableForm14.vue'
import TableForm15 from './Tables/TableForm15.vue'
import TableForm16 from './Tables/TableForm16.vue'
import TableForm17 from './Tables/TableForm17.vue'
import TableForm18 from './Tables/TableForm18.vue'
import TableForm19 from './Tables/TableForm19.vue'
import TableForm20 from './Tables/TableForm20.vue'
import TableForm22 from './Tables/TableForm22.vue'

import NewFormModal from './NewFormModal.vue'

@Component({
    components:{
        TableManualForms,
        TableForm1,
        TableForm2,
        TableForm3,
        TableForm4,
        TableForm5,
        TableForm6,
        TableForm7,
        TableForm8, 
        TableForm9,  
        TableForm10,
        TableForm11,
        TableForm12,
        TableForm13,
        TableForm14,
        TableForm15,
        TableForm16,
        TableForm17,
        TableForm18, 
        TableForm19,
        TableForm20,  
        TableForm22,     
        NewFormModal
    }
})
export default class MyDocumentsTable extends Vue {

    @Prop({required: true})
    title!: string;

    @Prop({required: true})
    enableActions!: boolean;

    showSelectFormToFill=false
   
    mounted() {        
    }

    public reload(){
        this.$emit('reload')
    }

    public CloseModal(){
        this.showSelectFormToFill=false
    }

}
